// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 2: ИСХОД
// ============================================================================
// Уровни 14-26 (13 уровней, 39 вопросов)

export const chapter2Translations = {
  name: 'Исход',
  description: 'Освобождение народа Божьего... Познание Бога преображает нашу жизнь',
  
  spiritualWisdom: {
    principle: 'Познание Бога освобождает и преображает',
    scripture: 'Познаете истину, и истина сделает вас свободными (Иоанна 8:32)',
    application: 'Как Израиль был освобожден из Египта, познание Бога освобождает нас от духовного рабства'
  },
  
  levels: {
    14: {
      name: 'Моисей, Спасенный из Воды',
      challenge: 'Женщина зачала и родила сына. Увидев, что он прекрасен...',
      easy: {
        question: 'Во что мать Моисея его спрятала?',
        options: ['Пещера', 'Тростниковая корзина', 'Корзина', 'Дом'],
        hint: 'Этот сосуд плавал на Ниле',
        funFact: '🏺 Тростниковая корзина была покрыта смолой для водонепроницаемости!'
      },
      medium: {
        question: 'Кто нашел Моисея в тростнике?',
        options: [
          'Дочь фараона',
          'Египетская служанка',
          'Его сестра Мариам',
          'Египетский жрец'
        ],
        hint: 'Член египетской царской семьи',
        funFact: '👑 Как ни парадоксально, именно семья фараона спасла того, кто бросит ему вызов!'
      },
      hard: {
        question: 'Как Божественное Провидение использует даже наших врагов?',
        options: [
          'Обращая их',
          'Направляя обстоятельства для исполнения Своих замыслов',
          'Наказывая их',
          'Игнорируя их'
        ],
        hint: 'Речь идет о том, чтобы видеть руку Божью в событиях',
        funFact: '✨ Моисей вырос во дворце того, кто угнетал его народ!'
      }
    },
    
    15: {
      name: 'Неопалимая Купина',
      challenge: 'Ангел Господень явился ему в пламени огня...',
      easy: {
        question: 'Что должен был снять Моисей перед неопалимой купиной?',
        options: ['Украшения', 'Обувь', 'Плащ', 'Тюрбан'],
        hint: 'То, что носят на ногах',
        funFact: '👡 Снятие обуви выражает уважение на святой земле!'
      },
      medium: {
        question: 'Какое имя открыл Бог Моисею?',
        options: [
          'Господь',
          'Я ЕСМЬ СУЩИЙ',
          'Всемогущий',
          'Творец'
        ],
        hint: 'Имя, выражающее абсолютное бытие',
        funFact: '🔥 ЯХВЕ (Я Есмь) раскрывает вечную сущность Бога!'
      },
      hard: {
        question: 'Чему нас учит купина, которая горит, но не сгорает?',
        options: [
          'Что существует магия',
          'Бог превосходит законы природы',
          'Огонь священен',
          'Растения магические'
        ],
        hint: 'Речь идет о божественной природе, превосходящей наше понимание',
        funFact: '🌿 Купина символизирует, что божественное присутствие освящает, не разрушая!'
      }
    },

    16: {
      name: 'Десять Египетских Казней',
      challenge: 'Фараон ожесточил свое сердце и не послушал их...',
      easy: {
        question: 'Какой была первая египетская казнь?',
        options: ['Жабы', 'Вода превращается в кровь', 'Мухи', 'Вши'],
        hint: 'Она затронула Нил, источник жизни Египта',
        funFact: '🩸 Нилу поклонялись как богу, и Бог показал Свое превосходство!'
      },
      medium: {
        question: 'Какой была последняя и самая ужасная из казней?',
        options: [
          'Град',
          'Тьма',
          'Смерть первенцев',
          'Саранча'
        ],
        hint: 'Эта казнь напрямую затронула семьи',
        funFact: '😢 Эта казнь окончательно сломила гордость фараона и освободила Израиль!'
      },
      hard: {
        question: 'Почему Бог ожесточил сердце фараона?',
        options: [
          'Чтобы наказать его',
          'Чтобы явить Свою славу и силу',
          'Из злобы',
          'Чтобы продлить страдания'
        ],
        hint: 'Речь идет о том, чтобы открыть, кто является истинным Богом',
        funFact: '⚡ Казни показывают, что ЯХВЕ могущественнее всех египетских богов!'
      }
    },

    17: {
      name: 'Пасха',
      challenge: 'Возьмите агнца... и помажьте кровью на обоих косяках...',
      easy: {
        question: 'Куда израильтяне должны были помазать кровь агнца?',
        options: [
          'На одежду',
          'На косяки и перекладины дверей',
          'На лбы',
          'В чаши'
        ],
        hint: 'У входа в дома',
        funFact: '🩸 Кровь на двери была знаком божественной защиты!'
      },
      medium: {
        question: 'Как должны были есть пасхального агнца?',
        options: [
          'Сидя удобно',
          'Только семьей',
          'С препоясанными чреслами, с обувью на ногах, с посохом в руке',
          'В молчании'
        ],
        hint: 'Готовыми к отправлению',
        funFact: '🚶 Они должны были быть готовы быстро отправиться к свободе!'
      },
      hard: {
        question: 'Как пасхальный Агнец прообразует Христа?',
        options: [
          'Своей белизной',
          'Своей заместительной жертвой, спасающей от смерти',
          'Своей кротостью',
          'Своим возрастом'
        ],
        hint: 'Речь идет о жертве, избавляющей от осуждения',
        funFact: '🐑 Иисуса называют Агнцем Божиим, берущим на Себя грех мира!'
      }
    },

    18: {
      name: 'Переход Через Красное Море',
      challenge: 'Моисей простер руку свою на море...',
      easy: {
        question: 'Как израильтяне пересекли море?',
        options: [
          'На лодке',
          'Вплавь',
          'По суше',
          'На плоту'
        ],
        hint: 'Морское дно стало проходимым',
        funFact: '🌊 Бог превратил препятствие в путь освобождения!'
      },
      medium: {
        question: 'Что случилось с египтянами, которые преследовали?',
        options: [
          'Они повернули назад',
          'Они были поглощены водами',
          'Они заблудились',
          'Они присоединились к Израилю'
        ],
        hint: 'Воды вернулись на них',
        funFact: '⚔️ Самая могущественная армия в мире была уничтожена в одно мгновение!'
      },
      hard: {
        question: 'Что символизирует этот переход в нашей духовной жизни?',
        options: [
          'Бегство от проблем',
          'Переход от рабства греха к свободе в Боге',
          'Превосходство Израиля',
          'Уничтожение врагов'
        ],
        hint: 'Речь идет о духовном преображении',
        funFact: '🗽 Красное море представляет крещение: смерть для ветхого, новая жизнь!'
      }
    },

    19: {
      name: 'Манна в Пустыне',
      challenge: 'Что это? Ибо не знали, что это...',
      easy: {
        question: 'Сколько времени падала манна?',
        options: ['10 лет', '20 лет', '40 лет', '50 лет'],
        hint: 'Столько же, сколько лет в пустыне',
        funFact: '🍞 В течение 40 лет Бог чудесным образом кормил 2 миллиона человек!'
      },
      medium: {
        question: 'Что происходило, если сохраняли манну более одного дня?',
        options: [
          'Она становилась вкуснее',
          'Она умножалась',
          'Она портилась и воняла',
          'Она затвердевала'
        ],
        hint: 'Кроме пятницы для субботы',
        funFact: '🪱 Бог так учил ежедневной зависимости от Него!'
      },
      hard: {
        question: 'Чему манна учит нас о доверии?',
        options: [
          'Запасаться на будущее',
          'Полагаться на ежедневное провидение Божье',
          'Работать усерднее',
          'Делиться поровну'
        ],
        hint: 'Речь идет о ежедневном доверии',
        funFact: '🙏 Хлеб наш насущный дай нам на сей день происходит из этого опыта!'
      }
    },

    20: {
      name: 'Вода из Скалы',
      challenge: 'Ударь в скалу, и из нее выйдет вода...',
      easy: {
        question: 'Как Моисей должен был ударить в скалу?',
        options: ['Рукой', 'Посохом', 'Ногой', 'Мечом'],
        hint: 'Инструмент, который дал ему Бог',
        funFact: '🪨 Простое послушание вызвало сверхъестественное чудо!'
      },
      medium: {
        question: 'Почему у людей была жажда?',
        options: [
          'Из-за жары',
          'Потому что в пустыне не было воды',
          'Из-за долгого путешествия',
          'Из-за болезни'
        ],
        hint: 'Речь идет об их окружении',
        funFact: '💧 Бог создал источник воды в засушливой пустыне!'
      },
      hard: {
        question: 'Как эта скала прообразует Христа?',
        options: [
          'Своей силой',
          'Будучи пораженной и дающей воду жизни',
          'Своим размером',
          'Своим местоположением'
        ],
        hint: 'Речь идет об источнике спасения',
        funFact: '⚡ Павел сказал: И скала была Христос (1 Коринфянам 10:4)!'
      }
    },

    21: {
      name: 'Десять Заповедей',
      challenge: 'Бог изрек все слова сии, говоря...',
      easy: {
        question: 'Где Бог дал Десять Заповедей?',
        options: ['В Египте', 'На горе Синай', 'В Ханаане', 'В пустыне'],
        hint: 'Святая гора с огнем и дымом',
        funFact: '🔥 Присутствие Божье заставило трястись всю гору!'
      },
      medium: {
        question: 'На чем были написаны Десять Заповедей?',
        options: [
          'На пергаменте',
          'На каменных скрижалях перстом Божиим',
          'На дереве',
          'На золоте'
        ],
        hint: 'Постоянный материал',
        funFact: '👆 Сам Бог написал Свой закон!'
      },
      hard: {
        question: 'Какова цель закона?',
        options: [
          'Спасать людей',
          'Открывать грех и показывать святую природу Бога',
          'Наказывать людей',
          'Порабощать людей'
        ],
        hint: 'Речь идет об открытии стандартов Божьих',
        funFact: '📜 Закон ведет нас к необходимости Христа!'
      }
    },

    22: {
      name: 'Золотой Телец',
      challenge: 'Они сняли украшения и принесли их Аарону...',
      easy: {
        question: 'Что сделал народ в отсутствие Моисея?',
        options: [
          'Новый шатер',
          'Золотого тельца',
          'Золотой памятник',
          'Новый жертвенник'
        ],
        hint: 'Предмет идолопоклонства',
        funFact: '🐄 Они оставили Бога освобождения, чтобы служить идолу!'
      },
      medium: {
        question: 'Как Моисей отреагировал на этот грех?',
        options: [
          'Обрадовался',
          'Разгневался и разбил скрижали',
          'Убежал',
          'Проигнорировал'
        ],
        hint: 'Его яростная реакция',
        funFact: '😢 Когда закон Божий был нарушен, Моисей разбил закон!'
      },
      hard: {
        question: 'Почему человеческое сердце склоняется к идолам?',
        options: [
          'Из-за невежества',
          'Желание полагаться на видимое и восстание против владычества Божьего',
          'Из-за дьявольского влияния',
          'Из-за слабости'
        ],
        hint: 'Речь идет о человеческой природе и желании видимого',
        funFact: '💔 Идолопоклонство заменяет Творца творением!'
      }
    },

    23: {
      name: 'Скиния',
      challenge: 'Пусть они сделают Мне святилище...',
      easy: {
        question: 'Что такое Скиния?',
        options: [
          'Дворец',
          'Переносное святилище Божье',
          'Склад',
          'Школа'
        ],
        hint: 'Место для присутствия Божьего',
        funFact: '⛺ Бог желал обитать среди Своего народа!'
      },
      medium: {
        question: 'Какое было самое святое место в Скинии?',
        options: [
          'Жертвенник',
          'Святое Святых',
          'Вход',
          'Стол хлебов'
        ],
        hint: 'Где находился Ковчег Завета',
        funFact: '✨ Только первосвященник мог входить туда раз в год!'
      },
      hard: {
        question: 'Что прообразовала Скиния?',
        options: [
          'Силу Израиля',
          'Еммануил, Бог с нами, исполненный Христом',
          'Важность священников',
          'Красоту ритуалов'
        ],
        hint: 'Речь идет о Боге, обитающем среди людей',
        funFact: '🙏 Иисус поставил Свою скинию среди нас (Иоанна 1:14)!'
      }
    },

    24: {
      name: 'Соглядатаи Ханаана',
      challenge: 'Пошли людей, чтобы высмотреть землю и народ...',
      easy: {
        question: 'Сколько соглядатаев было послано высмотреть Ханаан?',
        options: ['6', '10', '12', '24'],
        hint: 'По одному от каждого колена Израилева',
        funFact: '🕵️ 12 были посланы, но только 2 имели веру!'
      },
      medium: {
        question: 'Кто были два соглядатая с верой?',
        options: [
          'Моисей и Аарон',
          'Иисус Навин и Халев',
          'Аарон и Мариам',
          'Гедеон и Самсон'
        ],
        hint: 'Те, кто выжил, чтобы войти в Ханаан',
        funFact: '💪 Их вера была вознаграждена после 40 лет странствий!'
      },
      hard: {
        question: 'Каким было последствие неверия?',
        options: [
          'Были прощены немедленно',
          'Блуждали 40 лет в пустыне',
          'Были наказаны немедленно',
          'Были изгнаны'
        ],
        hint: 'Долгое последствие',
        funFact: '😢 Страх стоил целому поколению входа в обетованную землю!'
      }
    },

    25: {
      name: 'Медный Змей',
      challenge: 'Огненные змеи вошли в народ и кусали их...',
      easy: {
        question: 'Какого типа были змеи, которые кусали народ?',
        options: ['Зеленые', 'Огненные', 'Гигантские', 'Невидимые'],
        hint: 'Прилагательное, описывающее их смертельный эффект',
        funFact: '🐍 Эти змеи символизировали смертельные последствия греха!'
      },
      medium: {
        question: 'Что Бог повелел Моисею сделать, чтобы спасти народ?',
        options: [
          'Сделать лекарства',
          'Поднять медного змея на шесте',
          'Молиться',
          'Убить змей'
        ],
        hint: 'Акт веры',
        funFact: '⚕️ Простой акт взгляда спасал - символизируя веру!'
      },
      hard: {
        question: 'Как Иисус процитировал это событие, говоря о кресте?',
        options: [
          'Об опасности греха',
          'Как Моисей вознес змию в пустыне, так должен быть вознесен Сын Человеческий',
          'О необходимости послушания',
          'О силе молитвы'
        ],
        hint: 'Речь идет о спасении через веру',
        funFact: '✝️ Иисус был вознесен, как медный змей, чтобы спасти грешников!'
      }
    },

    26: {
      name: 'Обетованная Земля',
      challenge: 'Можешь видеть ее своими глазами, но не войдешь туда...',
      easy: {
        question: 'Кто провел Израиль через Иордан?',
        options: ['Моисей', 'Аарон', 'Иисус Навин', 'Халев'],
        hint: 'Преемник Моисея',
        funFact: '🚶 Имя Иисуса Навина имеет то же значение, что и Иисус: Господь спасает!'
      },
      medium: {
        question: 'Почему Моисей не мог войти в обетованную землю?',
        options: [
          'Был слишком стар',
          'За непослушание у вод Меривы',
          'Отказался вести народ',
          'Был болен'
        ],
        hint: 'Определенный предыдущий грех',
        funFact: '😢 Даже Моисей столкнулся с последствиями непослушания!'
      },
      hard: {
        question: 'Что символизирует Обетованная Земля?',
        options: [
          'Материальное богатство',
          'Исполнение обетований Божьих во Христе и наше небесное наследие',
          'Военные победы Израиля',
          'Конец пустыни'
        ],
        hint: 'Речь идет о духовном исполнении обетований Божьих',
        funFact: '🌿 Ханаан указывает на небесную родину, которая ждет нас!'
      }
    }
  }
};

export default chapter2Translations;
